export default class ExtranetOrdersIndex {
  constructor() {
    this.bindEvents();
    this.initDatatable();

    $("#order-step-filter").val("")
    this.step_filter.trigger('change');
  }

  bindEvents() {
    this.step_filter = $("#order-step-filter").select2({
      multiple: true,
      placeholder: "Selectionner des états",
      allowClear: true,
      closeOnSelect: false,
    })
  }

  initDatatable() {
    this.table = $("#orders-datatable").DataTable({
      "responsive": {
        details: {
          type: 'column',
          target: 'tr'
        }
      },
      "searching": true,
      stateSave: false,
      dom: 'rtp',
      "columnDefs": [
        {
          "targets": 0,
          "orderable": true,
          "visible": false
        },
        {
          "targets": -1,
          "orderable": false
        },
        {
          responsivePriority: 1, 
          targets: [1, 2, 8, 9]  // Reference number, date, status and action buttons are highest priority
        },
        {
          responsivePriority: 2,
          targets: [3, 4]  // Product and client entity are medium priority
        }
      ],
      "order": [[0, "desc"], [2, "desc"]],
      "language": {
        //url: '/assets/data-tables/locales/' + I18n.locale + '.json',
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right>"
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      drawCallback:function(){
        $(".dataTables_paginate > .pagination").addClass("pagination-rounded")
      }
    });

    this.initFilters();
  }

  initFilters() {
    let self = this;

    this.step_filter.change(function(e) {
      var selected = $(this).val();
      console.log(selected);
      // Column 7 (0-based index) contains the translated status in the view
      // DataTables uses 0-based column index; status is column index 7 in the table
      if (selected && selected.length > 0) {
        self.table.column(7).search(selected.join('|'), true, false).draw();
      } else {
        self.table.column(7).search('', false, false).draw();
      }
    });

    $("#order_customSearch").off('keyup').on('keyup', function() {
      self.table.search($(this).val()).draw();
    });
  }

  onDataChanged(data) {
  }

  onDestroy() {
    this.step_filter.select2('destroy');
    this.table.destroy();
  }
}